import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-registro-debito',
  templateUrl: './consulta-registro-debito.component.html',
  styleUrls: ['./consulta-registro-debito.component.scss']
})
export class ConsultaRegistroDebitoComponent implements OnInit {
  title = "REGISTRO DE DÉBITO";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'success';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    this.verificaRegistro();
  }

  verificaRegistro() {
    if(this.consulta.registros.length > 0) {
      this.status = "warning";
    }else {
      this.codigoControle = "SEMREGISTRO_OK";
    }
  }

}
